export const filterBriefsBySearchInput = (briefs, searchInput) => {
    if (!searchInput) {
        return briefs;
    }

    return briefs?.filter(brief => {
        const relevantBriefs = [brief];

        return relevantBriefs.some(
            brief =>
                [
                    "maxPrice",
                    "address",
                    "description",
                    "systemId",
                    "providerIds",
                    "status",
                    "contactName",
                    "companyName",
                    "companyContactName",
                    "companyContactEmail",
                    "companyPhone",
                    "briefNumber"
                ].some(key => String(brief[key])?.toLowerCase().includes(searchInput.toLowerCase())) ||
                searchInput === brief.briefId ||
                brief.assignedCSMs?.some(({email}) => email === searchInput.toLowerCase())
        );
    });
};
